import React from "react";
import { Table } from "@tanstack/react-table";
import { ApiResponse, MoData } from "../utils/types";

interface TablePaginationProps {
  table: Table<MoData>;
  data: ApiResponse | undefined;
  setPageIndex: (pageIndex: number) => void;
}

const TablePagination: React.FC<TablePaginationProps> = ({
  table,
  data,
  setPageIndex,
}) => {
  return (
    <>
      {data && data.last_page > 1 && (
        <div className="flex flex-col sm:flex-row items-center justify-between px-3 sm:px-6 py-4 bg-gray-50 gap-4">
          <div className="flex items-center gap-2 flex-wrap">
            {table.getCanPreviousPage() && (
              <button
                className="px-3 sm:px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 transition-colors duration-200 font-medium text-sm"
                onClick={() => table.previousPage()}
              >
                Previous
              </button>
            )}
            <div className="flex gap-1">
              {data.links
                .filter(
                  (link) =>
                    !link.label.includes("Previous") &&
                    !link.label.includes("Next")
                )
                .map((link, index) => (
                  <button
                    key={index}
                    className={`px-3 sm:px-4 py-2 rounded-lg text-sm ${
                      link.active
                        ? "bg-blue-600 text-white"
                        : "bg-gray-200 text-gray-800 hover:bg-gray-300"
                    } disabled:opacity-50 transition-colors duration-200 font-medium`}
                    onClick={() => {
                      if (link.page !== null) setPageIndex(link.page - 1);
                    }}
                    disabled={link.page === null}
                  >
                    {link.label}
                  </button>
                ))}
            </div>
            {table.getCanNextPage() && (
              <button
                className="px-3 sm:px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 transition-colors duration-200 font-medium text-sm"
                onClick={() => table.nextPage()}
              >
                Next
              </button>
            )}
          </div>
          <div className="text-sm text-gray-600 font-medium">
            Page {data.current_page} of {data.last_page} | Showing {data.from}{" "}
            to {data.to} of {data.total} entries
          </div>
        </div>
      )}
    </>
  );
};

export default TablePagination;
